import { Component } from '@angular/core';
import {
  stacked_area_chart_data,
  stacked_area_chart_ui,
} from './ngx-chart.data';

@Component({
  selector: 'mj-dsm',
  templateUrl: './dsm.component.html',
  styleUrls: ['./dsm.component.scss'],
})
export class DsmComponent {
  // Image picker setup:
  public showImagePicker: boolean = false;

  // Stacked area chart setup:
  public stacked_area_chart_ui: any;
  public stacked_area_chart_data: any;
  public text = '';

  constructor() {
    Object.assign(this, { stacked_area_chart_data });
    Object.assign(this, { stacked_area_chart_ui });
  }

  content = `<p>Welcome to Mojob</p>`;

  changed(data) {
    const html = data.html;
    const text = data.text;
    const delta = data.content.ops;

    console.log('HTML output: ' + html);
    console.log('Text output: ' + text);
    console.log('Delta output: ' + JSON.stringify(delta));
  }

  closeImagePicker() {
    this.showImagePicker = false;
  }

  onStackedAreaChartSelect(event) {
    console.log(event);
  }

  public stackedAreaXAxisFormatting(val) {
    return (
      val.toLocaleDateString() +
      ' ' +
      val.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    );

    // let localeSpecificTime = val.toLocaleTimeString();
    // return localeSpecificTime.replace(/:\d+ /, ' ');
    // return val.toLocaleDateString() + '';
  }
}
